module.exports = __webpack_public_path__ + "img/laspi1.0b51cedc.webp";